import React from 'react';
import AuthLayout from '../../components/AuthLayout.jsx';
import ProgressBar from '../../components/ProgressBar.jsx';

export default function SignupLayout({ progress, children, maxWidth = 'sm:max-w-2xl' }) {
  return (
    <AuthLayout>
      <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
        <div className={`sm:mx-auto sm:w-full ${maxWidth}`}>
          <div className="flex justify-center mb-6">
            <img src="/logo.png" alt="123CEU" className="h-12 w-auto" />
          </div>
          {progress && <ProgressBar steps={progress.steps} currentStep={progress.current} />}
        </div>

        <div className={`mt-8 sm:mx-auto sm:w-full ${maxWidth}`}>
          {children}
        </div>
      </div>
    </AuthLayout>
  );
}
